import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { ResponseExchangeRateLatestBatchDto } from '§A/exchangerate/dto/response-exchangerate-latestbatch.dto'

interface IStoreMeta {
  exchangeRates: {
    date: Date | null
    rates: {
      [key: string]: number
    }
  }
}

// Metadata Store
export const useStoreMeta = defineStore('meta', () => {
  const state = ref<IStoreMeta>({
    exchangeRates: {
      date: null,
      rates: {}
    }
  })

  const setExchangeRates = (payload: ResponseExchangeRateLatestBatchDto) => {
    state.value.exchangeRates.date = new Date(payload.date)
    state.value.exchangeRates.rates = payload.rates

    // Add EUR since it's not included in the API response
    state.value.exchangeRates.rates['EUR'] = 1
  }

  const currencyCodes = computed(() => {
    const codes = Object.keys(state.value.exchangeRates.rates)
    return codes.sort()
  })
  const exchangeRates = computed(() => state.value.exchangeRates.rates)

  return {
    state,
    setExchangeRates,
    currencyCodes,
    exchangeRates
  }
})
